const diitPasienColumn = [
    [
        {
            id: 'kelas',
            width: '50px',
            title: 'Kelas',
            rowspan: 2
        },
        {
            id: 'kamar',
            width: '50px',
            title: 'Kamar',
            rowspan: 2
        },
        {
            id: 'nama_pasien',
            width: '50px',
            title: 'Nama Pasien',
            rowspan: 2
        },
        {
            id: 'umur',
            width: '50px',
            title: 'Umur',
            rowspan: 2
        },
        {
            id: 'diitpasien',
            width: '50px',
            title: 'Diit Pasien',
            align: 'center',
            colspan: 4
        },
        {
            id: 'catatan',
            width: '50px',
            title: 'Catatan',
            align: 'center',
            colspan: 4
        },
    ],
    [
        {
            id: 'pagi',
            width: '30px',
            title: 'Pagi'
        },
        {
            id: 'siang',
            width: '30px',
            title: 'Siang'
        },
        {
            id: 'sore',
            width: '30px',
            title: 'Sore'
        },
        {
            id: 'jenis',
            width: '40px',
            title: 'Jenis'
        },
        {
            id: 'keterangan',
            width: '50px',
            title: 'Keterangan'
        },
        {
            id: 'alergi',
            width: '40px',
            title: 'Alergi'
        },
        {
            id: 'diagnosa',
            width: '50px',
            title: 'Diagnosa'
        },
        {
            id: 'asuransi',
            width: '30px',
            title: 'Asuransi'
        }
    ]

];

export default diitPasienColumn;
